import { appInsights } from '../../router/router';
import { getPageNameFromPath } from './routeMapping';

export interface TrackingEvent {
    name: string;
    properties: {
        description: string;
        [key: string]: any;
    };
}

export const trackPageView = (pathname: string, additionalProperties?: any) => {
    const pageName = getPageNameFromPath(pathname);
    appInsights.trackPageView({
        name: `Page View: ${pageName}`,
        properties: {
            description: `${localStorage.getItem('userEmail')} has viewed ${"'" + pageName + "'"} page`,
            pageName,
            path: pathname,
            ...additionalProperties
        }
    });
};

export const trackTabClick = (tabName: string, pageName: string) => {
    appInsights.trackPageView({
        name: `Sub Page View: ${tabName}`,
        properties: {
            description: `${localStorage.getItem("userEmail")} clicked on the '${tabName}' tab in ${pageName}`,
        },
    });
};